/* @flow */

import * as React from 'react';
import {SelectPicker as Picker} from 'shells/select-picker';
import * as ramda from 'ramda';

type Props = {
    label: string,
    input: {
        name: string,
        value: Object[] | ?Object,
        onChange: (selectedOptions: Object[] | ?Object) => any,
    },
    getFieldRef?: Function,
    multi?: boolean,
    truncateMultiOptions?: boolean,
};

// This component wraps our standard SelectPicker component with some logic that
// allows us to use it within a redux-form `Field`.
export function SelectPicker(props: Props) {
    const {input, label, multi, ...rest} = props;

    // Redux-form treats empty values as an empty string, but react-select doesn't
    // like that (or at least, our SelectPicker wrapper doesn't), so convert "invalid"
    // values into null
    let sanitizedSelectPickerValue =
        ramda.is(String, input.value) || ramda.isEmpty(input.value) ? null : input.value;

    // We expect an array value for a multiSelect
    if (multi && !sanitizedSelectPickerValue) {
        sanitizedSelectPickerValue = [];
    }

    return (
        <div>
            <Picker
                {...rest}
                multi={multi}
                name={input.name}
                value={sanitizedSelectPickerValue}
                onChange={input.onChange}
                label={`${label}${input.value ? '' : '…'}`}
                ref={(c) => {
                    if (typeof props.getFieldRef === 'function') props.getFieldRef(c);
                }}
            />
        </div>
    );
}
